export enum SummaryAggregation{
	SUM = 'SUM',
	AVG = 'AVG',
	MAX = 'MAX',
	MIN = 'MIN',
}
